var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 89"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.26 87.84H54.49L16.11 21.39h-.54c.76 11.74 1.15 20.11 1.15 25.11v41.34H0V0h23.59l38.32 65.79h.42c-.6-11.42-.91-19.49-.91-24.21V0h16.84v87.84z",
    fill: "#f59c27"
  })));
}
export default SvgN;